import React from "react";
import { Container, Header, NewChatContainer, SearchChatsContainer, Content, IconWrapper, DockWrapper, TooltipTrigger } from "./Sidebar.styled";
import { AgentsList, ChatsList } from "./components";
import { Typography, Icon, Tooltip } from "@ann/web-components";
import LogoAimsos from "../../../../../elements/icon/assets/logo_AIMSOS.svg";

const Sidebar = ({
  isCollapsed,
  onToggleCollapse,
  selectedConversationId,
  onSelectConversation,
  selectedAgentId,
  onSelectAgent,
  onNewChat,
  onSearchChats,
}) => {
  return (
    <Container>
      <Header $isCollapsed={isCollapsed}>
        <IconWrapper>
          <img src={LogoAimsos} alt="AIMS OS" width={16} height={16} />
        </IconWrapper>
        <DockWrapper onClick={onToggleCollapse}>
          <Tooltip
            content={isCollapsed ? "Open sidebar" : "Close sidebar"}
            align="start"
            zIndex={99999999}
            arrow={false}
          >
            <TooltipTrigger>
              <Icon color="neutral" name="dock_to_right" size="small" />
            </TooltipTrigger>
          </Tooltip>
        </DockWrapper>
        <IconWrapper className="sidebar-edit-icon-collapsed" onClick={isCollapsed ? onNewChat : undefined} role={isCollapsed ? "button" : undefined} tabIndex={isCollapsed ? 0 : undefined} onKeyDown={isCollapsed ? (e) => e.key === "Enter" && onNewChat?.() : undefined}>
          {isCollapsed ? (
            <Tooltip content="New chat" align="start" zIndex={99999999} arrow={false}>
              <TooltipTrigger>
                <Icon color="neutral" name="edit_square" size="small" />
              </TooltipTrigger>
            </Tooltip>
          ) : (
            <Icon color="neutral" name="edit_square" size="small" />
          )}
        </IconWrapper>
        <IconWrapper className="sidebar-search-icon-collapsed" onClick={isCollapsed ? onSearchChats : undefined} role={isCollapsed ? "button" : undefined} tabIndex={isCollapsed ? 0 : undefined} onKeyDown={isCollapsed ? (e) => e.key === "Enter" && onSearchChats?.() : undefined}>
          {isCollapsed ? (
            <Tooltip content="Search chats" align="start" zIndex={99999999} arrow={false}>
              <TooltipTrigger>
                <Icon color="neutral" name="search" size="small" />
              </TooltipTrigger>
            </Tooltip>
          ) : (
            <Icon color="neutral" name="search" size="small" />
          )}
        </IconWrapper>
      </Header>

      <Content $isCollapsed={isCollapsed}>
        <NewChatContainer
          $isCollapsed={isCollapsed}
          $isSelected={!selectedConversationId && !selectedAgentId}
          onClick={onNewChat}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && onNewChat?.()}
        >
          <Icon color="neutral" name="edit_square" size="small" />
          <Typography category="body" size="medium" weight="regular" color="body">
            New Chat
          </Typography>
        </NewChatContainer>

        <SearchChatsContainer
          $isCollapsed={isCollapsed}
          onClick={onSearchChats}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && onSearchChats?.()}
        >
          <Icon color="neutral" name="search" size="small" />
          <Typography category="body" size="medium" weight="regular" color="body">
            Search chats
          </Typography>
        </SearchChatsContainer>

        <AgentsList />

        <ChatsList
          selectedConversationId={selectedConversationId}
          onSelectConversation={onSelectConversation}
        />
      </Content>
    </Container>
  );
};

export default Sidebar;
